const GA_MEASUREMENT_ID = process.env.REACT_APP_GA_MEASUREMENT_ID;

const isBrowser = typeof window !== "undefined";

export const isAnalyticsEnabled = Boolean(GA_MEASUREMENT_ID) && isBrowser;

export const initAnalytics = () => {
  if (!isAnalyticsEnabled) return;
  if (typeof window.gtag === "function") return;
  if (document.getElementById("ga4-script")) return;

  const gaScript = document.createElement("script");
  gaScript.async = true;
  gaScript.src = `https://www.googletagmanager.com/gtag/js?id=${GA_MEASUREMENT_ID}`;
  gaScript.id = "ga4-script";
  document.head.appendChild(gaScript);

  window.dataLayer = window.dataLayer || [];
  window.gtag = function gtag() {
    window.dataLayer.push(arguments);
  };

  window.gtag("js", new Date());
  // Disable automatic page_view so route changes are tracked manually in SPA.
  window.gtag("config", GA_MEASUREMENT_ID, { send_page_view: false });
};

export const trackPageView = (path) => {
  if (!isAnalyticsEnabled || typeof window.gtag !== "function") return;

  window.gtag("event", "page_view", {
    page_path: path,
    page_location: window.location.href,
    page_title: document.title
  });
};

export const trackEvent = (eventName, params = {}) => {
  if (!isAnalyticsEnabled || typeof window.gtag !== "function") return;
  window.gtag("event", eventName, params);
};
